import React, { useState } from 'react';

export default function FilterStrip() {
  const [filters, setFilters] = useState({
    district: '', facility: '', category: '', period: ''
  });

  const handleChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const handleApply = () => {
    console.log('Applied Filters:', filters);
  };

  const handleReset = () => {
    setFilters({ district: '', facility: '', category: '', period: '' });
  };

  return (
    <div className="filter-strip">

      <div className="filter-group">
        <span className="filter-label">District</span>
        <select className="filter-select" name="district" value={filters.district} onChange={handleChange}>
          <option value="">All Districts (33)</option>
          <option>Kamrup</option>
          <option>Kamrup Metropolitan</option>
          <option>Dibrugarh</option>
          <option>Jorhat</option>
          <option>Nagaon</option>
          <option>Sonitpur</option>
          <option>Goalpara</option>
          <option>Cachar</option>
          <option>Lakhimpur</option>
          <option>Tinsukia</option>
        </select>
      </div>

      <div className="filter-divider"></div>

      <div className="filter-group">
        <span className="filter-label">Facility</span>
        <select className="filter-select" name="facility" value={filters.facility} onChange={handleChange}>
          <option value="">All Facility Types</option>
          <option>Medical College Hospital</option>
          <option>Civil / District Hospital</option>
          <option>Sub-Divisional Hospital (SDH)</option>
          <option>Community Health Centre (CHC)</option>
          <option>Primary Health Centre (PHC)</option>
          <option>Sub-Centre</option>
        </select>
      </div>

      <div className="filter-divider"></div>

      <div className="filter-group">
        <span className="filter-label">Category</span>
        <select className="filter-select" name="category" value={filters.category} onChange={handleChange}>
          <option value="">All Categories</option>
          <option>Antibiotics</option>
          <option>Analgesics &amp; Antipyretics</option>
          <option>Antihypertensives</option>
          <option>Antidiabetics</option>
          <option>Vaccines &amp; Immunologicals</option>
          <option>Maternal &amp; Child Health</option>
          <option>ORS &amp; IV Fluids</option>
        </select>
      </div>

      <div className="filter-divider"></div>

      <div className="filter-group">
        <span className="filter-label">Period</span>
        <select className="filter-select" name="period" value={filters.period} onChange={handleChange}>
          <option value="">March 2026 (Current)</option>
          <option>Last 3 Months</option>
          <option>Last 6 Months</option>
          <option>Financial Year 2025-26</option>
        </select>
      </div>

      <div className="filter-divider"></div>

      <button className="btn-apply" onClick={handleApply}>Apply Filters</button>
      <button className="btn-reset" onClick={handleReset}>Reset</button>

      <div className="active-filters" style={{ display: 'none' }}></div>
    </div>
  );
}
